module.exports = __webpack_public_path__ + "static/media/2.2fe8dd10.png";